import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { useEffect, useState } from "react";
import randomBytes from "randombytes";
import { TransactionTable } from "components/Transaction/AddTransaction/TransactionTable";
import { InternalTransaction } from "components/Transaction/AddTransaction/AddTransactionManuallyModal";
import { TapIcon } from "components/icons/TapIcon";
import { FormikForm } from "components/FormikForm/FormikForm";
import { useFormikContext } from "formik";

type TransactionRow = Omit<InternalTransaction, "id"> & { id: string };

type Props = {
  onTransactionsChange: (transactions: TransactionRow[]) => void;
};

const createEmptyRows = (count: number): TransactionRow[] =>
  Array.from({ length: count }).map(() => ({
    id: randomBytes(16).toString("hex"),
    date: "",
    merchant: "",
    category: "",
    description: "",
    amount: 0,
    invoice: null,
  }));

const INITIAL_TRANSACTIONS = createEmptyRows(3);

const ManualTransaction = ({
  onTransactionsChange,
}: {
  onTransactionsChange: (transactions: TransactionRow[]) => void;
}) => {
  const { values } = useFormikContext<{ transactions: TransactionRow[] }>();
  useEffect(() => {
    onTransactionsChange(values.transactions);
  }, [values.transactions]);
  return <TransactionTable duplicatable />;
};

export const AIReconcileManualAdditions = ({ onTransactionsChange }: Props) => {
  const [openItems, setOpenItems] = useState<string[]>([]);

  return (
    <Accordion.Root
      type="multiple"
      value={openItems}
      onValueChange={setOpenItems}
    >
      <Accordion.Item value="manual_additions">
        <Accordion.Trigger>
          <div className="t-flex t-gap-2">
            <span className="t-p-0.1 t-text-text-30">
              <TapIcon />
            </span>

            <div className="t-flex t-flex-col t-items-start t-gap-1">
              <span className="t-text-body-sm t-text-text-60">
                Manual Additions
              </span>
              <span className="t-text-body-sm-italic t-italic t-text-text-30">
                If the AI hasn't suggested a match you expect, feel free to add
                the transaction manually. It will be created in Books and
                reconciled automatically.
              </span>
            </div>
          </div>
        </Accordion.Trigger>
        <Accordion.Content
          forceMount
          className={
            openItems.includes("manual_additions") ? "t-block" : "t-hidden"
          }
        >
          <FormikForm
            initialValues={{ transactions: INITIAL_TRANSACTIONS }}
            onSubmit={() => {}}
          >
            <ManualTransaction onTransactionsChange={onTransactionsChange} />
          </FormikForm>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
